enum PosSoftwareCustomerStateEnum {
  InPreview = "InPreview",
  InIntegration = "InIntegration",
  Live = "Live",
}

export default PosSoftwareCustomerStateEnum;
